export const enClientPortalThreadListPagePages = {
    orders: {
        threadListPage: {
            noTitle: 'No title',
            saving: 'Saving...',
            taskDetails: 'Task details',
            goToOrder: 'To order',
            titlePlaceholder: 'Conversation topic',
            comments: 'Comments',
            pinned: 'Pinned',
            options: 'Options',
            notAvailable: 'Not available yet',
            external: 'External',
            subjectForExternalCollaboration: 'Email address for collaboration on order {{orderLabel}}',
            selection: {
                newConversation: 'New conversation',
                item: {
                    noTitle: 'No title',
                    notifiedUsersTooltip: 'No one is currently notified about new messages. Click here to add notified users.',
                    options: 'Options',
                    unpin: 'Unpin conversation',
                    pin: 'Pin conversation',
                    delete: 'Delete conversation',
                },
            },
            createDialog: {
                title: 'New conversation',
                create: 'Create',
                cancel: 'Cancel',
                topicLabel: 'Title *',
                participantsLabel: 'Add more notified users...',
                defaultNotifiedUsers: 'Default notified users for this new conversation:',
                yourself: 'You',
                creator: 'Creator',
                observers: 'Observers',
                assignees: 'Assignees',
                observersDescriptionSuffix: 'of the order, including',
            },
            emptyState: {
                loadingTitle: 'Conversations are loading...',
                emptyTitle: 'No open conversations',
                emptyDescriptionLineOne: 'Start a new conversation to ask questions, get support,',
                emptyDescriptionLineTwo: 'or share information with other users.',
                newConversation: 'New conversation',
            },
            orderDropdown: {
                loading: 'Loading order data...',
                label: 'Order',
                noOptions: 'No orders found',
                valuationDate: 'Valuation date',
                orderDate: 'Order date',
            },
            thread: {
                noMessages: 'No messages',
                deletedMessage: 'Message was deleted',
                createdBy: 'Conversation was created by {{userName}}',
                createdAutomatically: 'The conversation was created automatically',
            },
            participantTooltips: {
                none: 'No one is currently notified about new messages. Click here to add notified users.',
                notified: 'You are notified about new messages. Disable notifications.',
                notNotified: 'You are not notified about new messages. Enable notifications.',
                participantGroup: 'Notified users',
                observerGroup: 'Observers',
                observerTooltip:
                    "You're observing this order, so notifications can't be turned off here. Stop observing the order on its overview page.",
            },
            menu: {
                unpin: 'Unpin conversation',
                pin: 'Pin conversation',
                rename: 'Rename conversation',
                goToTask: 'To task',
                goToOrder: 'To order',
                editParticipants: 'Edit notified users',
                stopNotifications: 'Stop notifying me',
                notifyMe: 'Notify me',
                delete: 'Delete conversation',
                notificationSettings: 'To notification settings',
            },
            alerts: {
                notNotified: 'You are not notified about new messages in this conversation.',
                aloneStart: 'You are alone in this conversation. Add notified users',
                here: 'here',
                aloneEnd: 'to the conversation.',
                emptyParticipants: 'No one is currently notified about new messages.',
            },
            participantsDrawer: {
                title: 'Edit notified users',
                addParticipantsLabel: 'Add more notified users...',
                notifyMe: 'Notify me',
                participantCount_one: '{{count}} notified user',
                participantCount_other: '{{count}} notified users',
                observerCount_one: '{{count}} order observer',
                observerCount_other: '{{count}} order observers',
                editObservers: 'Edit observers',
                observerInfo:
                    'Observers receive email updates about all order news enabled in their notification settings. This includes order status changes, available drafts, new messages, and task updates. Edit your observer status on the order page.',
                responsible: 'Assignee',
            },
            message: {
                deleteTitle: 'Delete message',
                deleteDialogContent: 'Do you really want to permanently delete this message?',
                deleteConfirm: 'Delete permanently',
                edit: 'Edit message',
                delete: 'Delete message',
                edited: 'edited',
                attachments: 'Attachments',
                deletedMessage: 'Message was deleted',
                system: 'System',
            },
            textEditor: {
                noMentionResults: 'No results',
                placeholder: 'New message',
                attachmentTooLarge: 'The attachments are larger than 7.5 MB in total.',
                toolbar: {
                    textStyle: 'Text style',
                    bold: 'Bold',
                    italic: 'Italic',
                    bulletedList: 'Bulleted list',
                    numberedList: 'Numbered list',
                    headingOptions: {
                        paragraph: 'Text',
                        h2: 'Headline 1',
                        h3: 'Headline 2',
                        h4: 'Headline 3',
                        h5: 'Headline 4',
                    },
                },
            },
            externalEmail: {
                info: 'Messages and documents (max. 7.5 MB) are sent',
                infoSecondLine: 'to the external contact by email.',
                details: 'Email details',
                messageMetadata: {
                    sender: 'From',
                    recipient: 'To',
                    subject: 'Subject',
                },
            },
        },
    },
}
